export default __webpack_public_path__ + "static/media/morning-murmur.81b99cf2.mp3";